import * as React from 'react';
import styled from 'styled-components';
import { compose, space, color, layout, typography, SpaceProps, ColorProps, LayoutProps, TypographyProps } from 'styled-system';
import { nanoid } from 'nanoid';
export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement> & {
  title?: any;
}>(({
  title,
  ...props
}, svgRef) => {
  const [titleId] = React.useState(() => title ? nanoid() : undefined);
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="1em" height="1em" ref={svgRef} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M22.083 11.395C19.86 6.715 16.503 4.36 12 4.36c-4.505 0-7.86 2.356-10.083 7.039a1.413 1.413 0 000 1.207C4.14 17.285 7.497 19.64 12 19.64c4.505 0 7.861-2.356 10.083-7.039.18-.38.18-.82 0-1.207zM12 17.953c-3.78 0-6.548-1.917-8.5-5.953C5.451 7.964 8.22 6.047 12 6.047c3.78 0 6.549 1.917 8.5 5.953-1.95 4.036-4.717 5.953-8.5 5.953zm-.094-10.078a4.125 4.125 0 100 8.25 4.125 4.125 0 000-8.25zm0 6.75A2.624 2.624 0 019.281 12a2.624 2.624 0 012.625-2.625A2.624 2.624 0 0114.531 12a2.624 2.624 0 01-2.625 2.625z" /></svg>;
});
export const IconOtherEye = styled(SvgComponent)<IconProps>({
  flex: 'none',
  verticalAlign: 'middle'
}, compose(space, color, layout, typography));